<template>
  <a
    @click="redirectUser($event)"
    href="#"
    v-focus-if="focus"
    class="page-control"
  >
    <div class="card-body">
      <div class="row-align-items-center">
        <div class="col">
          <div class="card-title">{{ menuItem.title.toUpperCase() }}</div>
          <p>{{ menuItem.detailedDescription || menuItem.description }}</p>
        </div>
      </div>
    </div>
  </a>
</template>

<script>
/* eslint no-unneeded-ternary: 'off' */

//Need to match...https://www.cdc.gov/publichealthgateway/partnerships/index.html
import store from "@/store";
export default {
  props: ["menuItem", "onClick", "focus"],
  components: {
    // "page-buttons": pageButtons
  },
  created: function () {
    let vm = this;
  },
  data: function () {
    let vm = {};
    return vm;
  },
  methods: { redirectUser },
};

function redirectUser(e) {
  let vm = this;
  if (e) e.preventDefault();
  store.dispatch("display/clearMessages");
  if (vm.onClick) vm.onClick();
  else this.$router.push(vm.menuItem.url);
  return false;
}
</script>

<style scoped="">
a {
  text-decoration: none !important;
  background-color: #f0f0f0;
  color: #000;
  overflow: hidden;
  transition: 0.25s box-shadow;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.23);
  margin-bottom: 1rem;
  position: relative;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 0.25rem;
  box-sizing: border-box;
  border-top: 3px solid;
  border-top-color: #fbab18;
  font-family: "Open Sans", apple-system, blinkmacsystemfont, "Segoe UI",
    "Helvetica Neue", arial, sans-serif;
}
a:-webkit-any-link {
  text-decoration: none !important;
}

a:hover {
  box-shadow: 0 5px 11px 0 rgba(0, 0, 0, 0.18), 0 4px 15px 0 rgba(0, 0, 0, 0.15);
}

.card-body {
  padding: 1rem;
  flex: 1 1 auto;
  min-height: 1px;
  box-sizing: border-box;
  display: block;
}

.row-align-items-center {
  flex: 1 1 auto;
  min-height: 1px;
  padding: 0;
}
.card-title {
  padding: 0;
  margin: 0;
  flex: 1 1 auto;
  min-height: 1px;
  position: relative;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-clip: border-box;
  border-radius: 0.25rem;

  line-height: 1.3;
  font-size: 1.375rem;
  text-decoration: none !important;
}
p {
  padding: 0;
  margin: 0;
  text-decoration: none !important;
}
</style>
